import React, { createContext, useContext, useState, ReactNode } from 'react';

interface TaraSearchContextType {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  isSearchActive: boolean;
  setIsSearchActive: (active: boolean) => void;
}

const TaraSearchContext = createContext<TaraSearchContextType | undefined>(undefined);

export const TaraSearchProvider = ({ children }: { children: ReactNode }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isSearchActive, setIsSearchActive] = useState(false);

  return (
    <TaraSearchContext.Provider value={{ searchTerm, setSearchTerm, isSearchActive, setIsSearchActive }}>
      {children}
    </TaraSearchContext.Provider>
  );
};

export const useTaraSearch = () => {
  const context = useContext(TaraSearchContext);
  if (!context) {
    throw new Error('useTaraSearch must be used within a TaraSearchProvider');
  }
  return context;
};
